import { registerPlugin } from "@capacitor/core";

export interface RoutePoint {
  lat: number;
  lng: number;
}

export interface ShowRouteOptions {
  /** Array of coordinates to display as a route */
  points: RoutePoint[];
  /** Title shown in the info card */
  title?: string;
  /** Total miles to display */
  totalMiles?: number;
  /** Enable route adjustment mode - allows dragging start/end markers */
  adjustable?: boolean;
}

export interface ShowRouteFromSessionOptions {
  /** Session ID to load route from native database */
  sessionId: string;
  /** Title shown in the info card */
  title?: string;
}

export interface ShowRouteResult {
  /** True when the map was dismissed */
  dismissed: boolean;
  /** Adjusted miles if user modified the route endpoints */
  adjustedMiles?: number;
  /** Start point index in the original points array */
  startIndex?: number;
  /** End point index in the original points array */
  endIndex?: number;
  /** Whether the user made and saved adjustments */
  wasAdjusted?: boolean;
}

export interface AppleMapPlugin {
  /**
   * Show a route on a native Apple Maps view.
   * Opens a fullscreen map with the route polyline, start/end markers,
   * and an info card showing the title and total distance.
   */
  showRoute(options: ShowRouteOptions): Promise<ShowRouteResult>;

  /**
   * Show a route from a stored session ID.
   * Loads the route points from the native SQLite database
   * and displays them on the map.
   */
  showRouteFromSession(
    options: ShowRouteFromSessionOptions
  ): Promise<ShowRouteResult>;
}

const AppleMap = registerPlugin<AppleMapPlugin>("AppleMap", {
  web: () => import("./apple-map-web").then((m) => new m.AppleMapWeb()),
});

export default AppleMap;
